import React from 'react';
import { ZonedDateTimeRangeDto } from '@api/ChallengeClient';
import { DatePicker } from '@components/date-picker';

interface AttributionDayFieldProps {
    value: string;
    range?: ZonedDateTimeRangeDto;
    onChange(value: string): void;
}

export function dayBoundsOf(range?: ZonedDateTimeRangeDto) {
    return {
        min: range?.from?.slice(0, 10),
        max: range?.to?.slice(0, 10)
    };
}

export function defaultAttributionDay(range?: ZonedDateTimeRangeDto) {
    const { min, max } = dayBoundsOf(range);
    const today = new Date().toISOString().slice(0, 10);
    if (min && today < min) {
        return min;
    }
    if (max && today > max) {
        return max;
    }
    return today;
}

export function isDayInRange(day: string, range?: ZonedDateTimeRangeDto) {
    const { min, max } = dayBoundsOf(range);
    if (!day) {
        return false;
    }
    return (!min || day >= min) && (!max || day <= max);
}

const toIsoDay = (value: Date | null) => {
    if (!value) {
        return '';
    }
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${value.getFullYear()}-${month}-${day}`;
};

const fromIsoDay = (value?: string) =>
    value ? new Date(`${value}T00:00:00`) : null;

export function AttributionDayField({
    value,
    range,
    onChange
}: AttributionDayFieldProps) {
    const { min, max } = dayBoundsOf(range);

    return (
        <div className="flex flex-col gap-1.5">
            <DatePicker
                label="Attribute to day"
                value={fromIsoDay(value)}
                minDate={fromIsoDay(min) ?? undefined}
                maxDate={fromIsoDay(max) ?? undefined}
                onChange={(next) => onChange(toIsoDay(next))}
            />
            <p className="text-xs text-muted-foreground">
                {`The change is booked on this day of the challenge${
                    min && max ? ` (${min} – ${max})` : ''
                }`}
            </p>
        </div>
    );
}
